import { post } from '../../../infra/rest';
import {
  OrgListCustomersResponse,
  OrgListCustomersResponsePaginationArgs,
} from '../../home/types';

interface FilterType {
  search?: string;
  sort?: {
    sortBy: string;
    direction: string;
  };
}

const getOrganisationAPI = async (
  partnerId?: string,
  filter?: FilterType,
  nextClientDateCreated?: OrgListCustomersResponsePaginationArgs
) => {
  if (!partnerId) {
    throw new Error('Channel details not found');
  }

  return post<OrgListCustomersResponse>(
    `/v1/channel-partner/${partnerId}/customer/list`,
    {
      body: JSON.stringify({
        searchFilter: filter?.search,
        sortFilter: filter?.sort?.sortBy ? filter.sort : undefined,
        paginationOptions: nextClientDateCreated,
      }),
    },
    true
  );
};

export default getOrganisationAPI;
